import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { CreateInvitesSuccess } from '@webapp/store/invites/action-creators';
import { CREATE_INVITES_SUCCESS } from '@webapp/store/invites/actions';
import { getInviterName } from '../../../../../../../services/invites/utils/get-inviter-name';

export const trackInviteSent = (action$: Observable<CreateInvitesSuccess>) =>
  action$.pipe(
    ofType(CREATE_INVITES_SUCCESS),
    map((action) => {
      if (window.analytics) {
        action.invites.forEach((invite) => {
          window.analytics.track('Invite Sent', {
            id: invite.id,
            inviter: {
              id: invite.inviterId,
              name: getInviterName(invite.metadata)
            },
            invitee: {
              email: invite.contact_type === 'email' ? invite.email_or_phone : undefined,
              phone: invite.contact_type === 'sms' ? invite.email_or_phone : undefined,
              name: invite.name || undefined,
              role: invite.role || undefined
            },
            inviteType: invite.type
          });
        })
      }
    }),
    filter(() => false)
  )